module.exports = __webpack_public_path__ + "img/L1020128.ece5ffb7.jpg";